import LandingComponent from "../components/LandingComponent";
import { Footer } from "../components/share/Footer";
// import { NavMenu } from "../../components/NavMenu";
import { NavbarComponent } from "../components/share/NavbarComponent";

export function LandingContainer() {
    return (

        <div className="page-container bg-landing">
            <NavbarComponent />
            <LandingComponent />
            <Footer />
        </div>
    );
}
